const TOKEN_KEY = 'tsrAdminToken';

export const getTsrAdminToken = () => sessionStorage.getItem(TOKEN_KEY) || '';

export const setTsrAdminToken = (token) => {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

export const clearTsrAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

export const isTsrAdminAuthenticated = () => Boolean(getTsrAdminToken());
